import React from 'react';
import Select from 'react-select';

export default class SelectInput extends React.Component {
	constructor(args) {
		super(args);
		this.element = null;
	}

	componentDidMount() {
		this.setTitle(this.props.title);
	}

	componentWillReceiveProps(newProps) {
		this.setTitle(newProps.title);
	}

	setTitle(title) {
		if (this.element) {
			let selectControl = $(this.element.control);
			if (title) {
				selectControl.attr('title', title);
			} else {
				selectControl.removeAttr('title');
			}
		}
	}

	handleBlur(e) {
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
	}

	render() {
		return (
			<Select id={this.props.id}
			        placeholder=""
			        optionRenderer={this.props.optionRenderer}
			        valueRenderer={this.props.valueRenderer}
			        noResultsText="Ничего не найдено"
			        className={this.props.className}
			        ref={e => this.element = e}
			        clearable={this.props.clearable}
			        backspaceRemoves={this.props.clearable}
			        deleteRemoves={this.props.clearable}
			        multi={this.props.multi}
			        options={this.props.options}
			        value={this.props.value}
			        onChange={e => this.props.onChange(e)}
			        onBlur={e => this.handleBlur(e)}
			        disabled={!!this.props.disabled}
			/>
		);
	}
}


// WEBPACK FOOTER //
// ./App/controls/selectInput.jsx